import React from "react";
import Title from "../title";
import styled from "styled-components";
import {Button} from "../../styles/globalStyles";
import {device} from "../../styles/breakpoints";


const StyledButton = styled(Button)`
  width: 100%;
  height: 50px;

  &::placeholder {
    color: #fff;
    padding: 10px 15px;
    font-weight: 400;
  }

  &:nth-child(3) {
    height: 200px;
  }

  @media ${device.tablet} {
    &:nth-child(3) {
      grid-column: 1/-1;
    }
    &:last-child {
      grid-column: 1/-1;
      width: 50%;
      justify-self: center;
    }
  }
`;

const StyledForm = styled.form`
  width: 100%;
  height: 400px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  @media ${device.tablet} {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    align-items: center;
    grid-template-rows: 1fr 2fr 1fr;
  }


`;

const FormSection = () => {

  return (
    <>
      <Title h1='Contact us' isButtonShow={false}>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas
        purus odio tempor rutrum...</Title>
      <StyledForm>
        <StyledButton as={'input'} placeholder={'Your Name'} type="text"/>
        <StyledButton as={'input'} placeholder={'Your Email Address'} type="text"/>
        <StyledButton as={'textarea'} placeholder={'Your Text'}/>
        <StyledButton as={'button'} type={'submit'}>Submit</StyledButton>
      </StyledForm>

    </>
  )
};

export default FormSection;

